import React from 'react';
import { CalendlyWidget } from '../components/common/Calendly';

const Schedule: React.FC = () => {
  // Replace with your actual Calendly URL
  const calendlyUrl = 'https://calendly.com/joey-pandina';

  return (
    <div className="schedule-page">
      <div className="container py-5">
        <h1 className="display-4 text-center mb-4">Schedule a Tutoring Session</h1>
        
        <div className="row mb-5">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow mb-4">
              <div className="card-body">
                <h2 className="card-title mb-4">Book Your Session</h2>
                <p className="card-text mb-4">
                  Use the calendar below to schedule a tutoring session. You can select the date, time, and type of session that works best for you.
                </p>
                
                <div className="scheduling-instructions mb-4">
                  <h3 className="h5">How It Works:</h3>
                  <ol>
                    <li>Select your preferred service (Middle School or High School Tutoring)</li>
                    <li>Choose an available date and time</li>
                    <li>Fill in your contact information</li>
                    <li>Add any notes about specific topics you'd like to cover</li>
                    <li>Receive a confirmation email with details and meeting link</li>
                  </ol>
                </div>
                
                {/* Calendly inline widget */}
                <CalendlyWidget url={calendlyUrl} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
